// leverage.js
import HTTP from "@/_helpers/http";
import { LEVERAGE__API } from "@/_helpers/urls";
import { LEVERAGE__MUTATIONS } from "../mutation-types";
import { LEVERAGE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  leverages: [],
  userleverages: [],
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [LEVERAGE__MUTATIONS.LEVERAGE](state, data) {
    state.leverages = data;
  },
  [LEVERAGE__MUTATIONS.USERLEVERAGE](state, data) {
    state.userleverages = data;
  },
};

// Actions
const actions = {
  async [LEVERAGE__ACTIONS.LEVERAGE]({ commit }) {
    try {
      const url = `${LEVERAGE__API.LEVERAGE}`;
      const response = await HTTP().get(url);
      commit(LEVERAGE__MUTATIONS.LEVERAGE, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [LEVERAGE__ACTIONS.USERLEVERAGE]({ commit }, id) {
    try {
      const url = `${LEVERAGE__API.USERLEVERAGE}/${id}`;
      const response = await HTTP().get(url);
      commit(LEVERAGE__MUTATIONS.USERLEVERAGE, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [LEVERAGE__ACTIONS.CREATELEVERAGE]({ dispatch }, parameter) {
    try {
      const url = `${LEVERAGE__API.CREATELEVERAGE}`;
      const response = await HTTP().post(url, { leverage: parameter.leverage });
      if (response.status === 200) {
        toast.success("Created Successfully");
      }
      await dispatch(LEVERAGE__ACTIONS.LEVERAGE);
    } catch (error) {
      console.log(error);
    }
  },
  async [LEVERAGE__ACTIONS.DELETELEVERAGE]({ dispatch }, parameter) {
    try {
      const url = `${LEVERAGE__API.DELETELEVERAGE}/${parameter?.id}`;
      await HTTP().delete(url);
      toast.success("Deleted Successfully");
      await dispatch(LEVERAGE__ACTIONS.LEVERAGE);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
